// extracted by mini-css-extract-plugin
export default {"Contact":"Contact_Contact__Es1ST","slide-in":"Contact_slide-in__95Xhc","Heading":"Contact_Heading__L1jKl","Description":"Contact_Description__yAzSF"};